import { BRAZIL_MAP_VIEWBOX, BRAZIL_UF_SHAPES } from "~/lib/domain/brazil-geometry";

/** Decorative geography only: no session data, coverage or interactive UF state.
 * Geometry © @svg-maps/brazil contributors, CC BY 4.0 (via the shared module).
 */
export function TerritoryLoadingMap() {
  return (
    <svg viewBox={BRAZIL_MAP_VIEWBOX} aria-hidden="true" focusable="false">
      {BRAZIL_UF_SHAPES.map(({ uf, path }) => (
        <path key={uf} d={path} />
      ))}
    </svg>
  );
}
